import { Breakpoints, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledPaginatorContainer = styled.div`
  display: flex;
  margin-top: ${getSpacing('s')};
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: ${getSpacing('s')};
  @media (max-width: ${Breakpoints.Mobile}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${getSpacing('s')};
  }
`;

interface StyledPaginatorItemProps {
  alignRight?: boolean;
}

export const StyledPaginatorItem = styled.div<StyledPaginatorItemProps>`
  display: flex;
  gap: ${getSpacing('s')};
  align-items: center;
  flex-wrap: wrap;
  @media (min-width: ${Breakpoints.Mobile}px) {
    justify-content: ${(p) => (p.alignRight ? 'flex-end' : 'flex-start')};
  }
`;

export const StyledPaginatorSelectWrapper = styled.div`
  display: flex;
  gap: ${getSpacing('xs')};
  align-items: center;
`;
